<template>
    <div>
        <SalesTaxSummary
            v-if="reportId == CREPORT.TYPE.SALES_TAX_SUMMARY"
            :data="data"
        />
        <SalesProviderSummary
            v-if="reportId == CREPORT.TYPE.SALES_BY_PROVIDER_SUMMARY"
            :data="data"
            :dialogs="dialogs"
        />
        <SalesProviderDetails
            v-if="reportId == CREPORT.TYPE.SALES_BY_PROVIDER_DETAILS"
            :data="data"
        />
        <TransactionsDetail
            v-if="reportId == CREPORT.TYPE.TRANSACTIONS_DETAIL"
            :data="data"
        />
        <TransactionByProvider
            v-if="reportId == CREPORT.TYPE.TRANSACTION_BY_PROVIDER"
            :data="data"
        />
        <OutOfPeriodAdjustments
            v-if="reportId == CREPORT.TYPE.OUT_OF_PERIOD_ADJUSTMENTS"
            :data="data"
        />
        <CashReconciliation
            v-if="reportId == CREPORT.TYPE.CASH_RECONCILIATION"
            :data="data"
        />
        <EndOfDayReconciliation
            v-if="reportId == CREPORT.TYPE.EOD_RECONCILIATION"
            :data="data"
        />

        <Returns v-if="reportId == CREPORT.TYPE.RETURNS" :data="data" />

        <DeclinedItems
            v-if="reportId == CREPORT.TYPE.DECLINED_ITEMS"
            :data="data"
        />
        <DiscountDetails
            v-if="reportId == CREPORT.TYPE.DISCOUNT_DETAILS"
            :data="data"
        />
        <DiscountSummary
            v-if="reportId == CREPORT.TYPE.DISCOUNTS_SUMMARY"
            :data="data"
        />
        <DonationsDetails
            v-if="reportId == CREPORT.TYPE.DONATIONS_DETAILS"
            :data="data"
        />
        <AROutOfPeriodSales
            v-if="reportId == CREPORT.TYPE.AR_OUT_OF_PERIOD_SALES"
            :data="data"
        />
        <AccountReceivableReconciliation
            v-if="reportId == CREPORT.TYPE.ARR"
            :data="data"
        />
        <CollectionsDetailByType
            v-if="reportId == CREPORT.TYPE.COLLECTION_DETAILS_BY_TYPE"
            :data="data"
        />
        <BillingDetail
            v-if="reportId == CREPORT.TYPE.BILLING_DETAIL"
            :data="data"
        />
        <PaymentByProvider
            v-if="reportId == CREPORT.TYPE.PAYMENT_BY_PROVIDER"
            :data="data"
        />
        <WriteOffs v-if="reportId == CREPORT.TYPE.WRITE_OFFS" :data="data" />

        <!-- REPORT WITH GRAPH -->
        <AverageClientTransaction
            v-if="reportId == CREPORT.TYPE.AVERAGE_CLIENT_TRANSACTION"
            :data="data"
        />
        <MonthlyPaymentsSummary
            v-if="reportId == CREPORT.TYPE.MONTHLY_PAYMENTS_SUMMARY"
            :data="data"
        />
        <MonthlyBillingSummary
            v-if="reportId == CREPORT.TYPE.MONTHLY_BILLING_SUMMARY"
            :data="data"
        />
        <AccountsReceivable
            v-if="reportId == CREPORT.TYPE.ACCOUNTS_RECEIVABLE"
            :data="data"
        />
        <CharitableFund
            v-if="reportId == CREPORT.TYPE.CHARITABLE_FUND"
            :data="data"
        />
        <CreditsApplied
            v-if="reportId == CREPORT.TYPE.CREDITS_APPLIED"
            :data="data"
        />
        <ProductionCreditBySales
            v-if="reportId == CREPORT.TYPE.PRODUCTION_CREDIT_BY_SALES"
            :data="data"
        />
        <ProductionCreditByPayments
            v-if="reportId == CREPORT.TYPE.PRODUCTION_CREDIT_BY_PAYMENTS"
            :data="data"
        />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import AROutOfPeriodSales from "@/components/report-billing/ar-out-of-period-sales";
import CashReconciliation from "@/components/report-billing/cash-reconciliation";
import CollectionsDetailByType from "@/components/report-billing/collection-details-by-type";
import DeclinedItems from "@/components/report-billing/declined-items";
import DiscountDetails from "@/components/report-billing/discount-details";
import DiscountSummary from "@/components/report-billing/discount-summary";
import DonationsDetails from "@/components/report-billing/donations-details";
import BillingDetail from "@/components/report-billing/billing-detail-by-invoice";
import EndOfDayReconciliation from "@/components/report-billing/end-of-day-reconciliation";
import OutOfPeriodAdjustments from "@/components/report-billing/out-of-period-adjustments";
import PaymentByProvider from "@/components/report-billing/payment-by-provider";
import WriteOffs from "@/components/report-billing/write-offs";
import SalesProviderSummary from "@/components/report-billing/sales-provider-summary";
import SalesProviderDetails from "@/components/report-billing/sales-provider-details";
import SalesTaxSummary from "@/components/report-billing/sales-tax-summary";
import TransactionByProvider from "@/components/report-billing/transaction-by-provider";
import TransactionsDetail from "@/components/report-billing/transactions-detail";
import Returns from "@/components/report-billing/returns";
import AccountReceivableReconciliation from "@/components/report-billing/arr-wrapper";
import AverageClientTransaction from "@/components/report-billing/average-client-transaction";
import MonthlyPaymentsSummary from "@/components/report-billing/monthly-payments-summary";
import MonthlyBillingSummary from "@/components/report-billing/monthly-billing-summary";
import AccountsReceivable from "@/components/report-billing/accounts-receivable";
import CharitableFund from "@/components/report-billing/charitable-fund";
import CreditsApplied from "@/components/report-billing/credits-applied";
import ProductionCreditBySales from "@/components/report-billing/production-credit-by-sales";
import ProductionCreditByPayments from "@/components/report-billing/production-credit-by-payments";

export default {
    components: {
        AccountReceivableReconciliation,
        AROutOfPeriodSales,
        CashReconciliation,
        CollectionsDetailByType,
        DeclinedItems,
        DiscountDetails,
        DiscountSummary,
        DonationsDetails,
        BillingDetail,
        EndOfDayReconciliation,
        OutOfPeriodAdjustments,
        PaymentByProvider,
        WriteOffs,
        Returns,
        SalesProviderSummary,
        SalesProviderDetails,
        SalesTaxSummary,
        TransactionByProvider,
        TransactionsDetail,
        AverageClientTransaction,
        MonthlyPaymentsSummary,
        MonthlyBillingSummary,
        AccountsReceivable,
        CharitableFund,
        CreditsApplied,
        ProductionCreditBySales,
        ProductionCreditByPayments
    },
    props: {
        data: {
            default() {},
            type: Object
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    data() {
        return { CREPORT: CREPORT };
    }
};
</script>
